import { render, staticRenderFns } from "./wzzj3.vue?vue&type=template&id=638d5130&scoped=true&"
import script from "./wzzj3.vue?vue&type=script&lang=js&"
export * from "./wzzj3.vue?vue&type=script&lang=js&"
import style0 from "./wzzj3.vue?vue&type=style&index=0&id=638d5130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d5130",
  null
  
)

export default component.exports